let x = 1;

export const generateId = () => x++;



// WEBPACK FOOTER //
// ./src/util/generate-id.ts